module.exports = __webpack_public_path__ + "img/idle-dj-details5.4bbee4d3.png";